import { motion } from "framer-motion";

const cards = [
  {
    number: "01",
    title: "It builds up",
    body:
      "Every hour the reward pot is swapped into NVDA, SPCX, and SPY tokens and credited to active cats by weight.",
  },
  {
    number: "02",
    title: "It travels",
    body:
      "When you sell or transfer a cat, the stock tokens inside its vault go with it. The NFT is the wallet.",
  },
  {
    number: "03",
    title: "It is yours",
    body:
      "Only the current ownerOf(tokenId) can claim the vault balance. No one else can touch it.",
  },
  {
    number: "04",
    title: "Only you",
    body:
      "No multi-sig, no escrow, no back door. Your keys, your cat, your stock tokens.",
  },
];

export function VaultSection() {
  return (
    <section className="relative overflow-hidden bg-background py-20 md:py-28">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="mb-12 max-w-2xl">
          <p className="font-pixel text-xs text-[var(--accent-green)]">THE VAULT</p>
          <h2 className="mt-2 font-pixel text-2xl text-foreground md:text-4xl">
            THE STOCK LIVES INSIDE THE NFT.
          </h2>
          <p className="mt-3 text-muted-foreground">
            Every Cat Claw carries its own vault. What is inside goes with it when it sells.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {cards.map((card, index) => (
            <motion.div
              key={card.number}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="rounded-2xl border border-border bg-card p-6 transition-colors hover:border-[var(--accent-green)]/30"
            >
              <span className="font-pixel text-2xl text-[var(--accent-green)]">{card.number}</span>
              <h3 className="mt-4 text-lg font-bold text-foreground">{card.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{card.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
